import React, {Component} from 'react';
import {graphql, compose} from 'react-apollo';
import {autobind} from 'core-decorators';
import addressesQuery from 'graphql/queries/addresses.gql';
import deleteAddressMutation from 'graphql/mutations/addresses/delete-address.gql';
import setDefaultAddressMutation from 'graphql/mutations/addresses/set-default-address.gql';
import AddressGridForm from 'views/addresses/address-grid-form';
import Spinner from 'components/spinner';
import SectionBanner from 'components/section-banner';
import styles from './styles.css';

@compose(
    graphql(addressesQuery, {
        name: 'addressesData',
        options: {
            fetchPolicy: 'network-only',
        },
    }),
    graphql(deleteAddressMutation, {
        props: ({mutate}) => ({
            onDeleteAddress: variables => mutate({variables}),
        }),
    }),
    graphql(setDefaultAddressMutation, {
        props: ({mutate}) => ({
            onSubmit: variables => mutate({
                variables,
                refetchQueries: [{query: addressesQuery}],
            }),
        }),
    }),
)
@autobind
export default class AddressBook extends Component {
    async handleDelete(id) {
        try {
            await this.props.onDeleteAddress({id});
            this.props.addressesData.refetch(); // We need to manually refetch query to update the list
        } catch (error) {
            alert('Hubo un error eliminando la dirección, por favor intentá nuevamente.');
        }
    }

    render() {
        if (this.props.addressesData.loading) return <Spinner />;
        return (
            <div className={styles.root}>
                <SectionBanner />
                <AddressGridForm
                    addresses={this.props.addressesData.addresses}
                    onDelete={this.handleDelete}
                    onSubmit={this.props.onSubmit}
                    returnUrl={this.props.location.state ? this.props.location.state.returnUrl : null}
                    returnData={this.props.location.state ? this.props.location.state.returnData : null}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/addresses/address-book/index.js